import { track, useAutoNavigate, useReturnToPath } from '@betterment/js-runtime';

import NoFeeChecking from './NoFeeChecking';

import FullPageLoader from '../../../Shared/components/FullPageLoader';
import { locationAssign } from '../../../Shared/path-helpers';
import { urlBuilder } from '../../../Shared/urlBuilder';
import { useUser } from '../../contexts/UserProvider';
import { CloseButton, ModalContent, ModalOverlay } from '../../modal-helpers';
import { isVerifiable, isVerified } from '../../models/card';
import { isVerified as isVerifiedCustomer } from '../../models/customer';
import { useCustomerResponse } from '../CustomerResponseProvider';

const NoFeeCheckingSplash: React.FC = () => {
  const navigateRouter = useAutoNavigate();
  const { user } = useUser();
  const { customer, loading: isCustomerLoading } = useCustomerResponse();
  const returnToPath = useReturnToPath(urlBuilder.appHome.absolute());

  if (isCustomerLoading && !customer) {
    return <FullPageLoader />;
  }

  const isCheckingEligible = !customer && user?.checkingEligibilityStatus === 'eligible';

  const isVerifiedCustomerWithPendingCard =
    customer?.card && isVerifiedCustomer(customer) && isVerifiable(customer.card);
  const isVerifiedCustomerWithVerifiedCard =
    customer?.card && isVerifiedCustomer(customer) && isVerified(customer.card);

  const handleClick = () => {
    if (isCheckingEligible) {
      track('ElementClicked', { name: 'OpenChecking' });
      void navigateRouter(urlBuilder.getAppCheckingAbout.absolute());
    } else if (isVerifiedCustomerWithPendingCard) {
      track('ElementClicked', { name: 'ActivateCard' });
      void navigateRouter(urlBuilder.getAppCheckingCardSetup.absolute());
    } else if (isVerifiedCustomerWithVerifiedCard) {
      track('ElementClicked', { name: 'ViewCheckingAccount' });
      void navigateRouter(urlBuilder.getAppChecking.absolute());
    }
  };

  let buttonCopy;
  let shouldDisplayFlash = false;

  if (isCheckingEligible) {
    buttonCopy = 'Open Checking';
  } else if (isVerifiedCustomerWithPendingCard) {
    buttonCopy = 'Activate card';
  } else if (isVerifiedCustomerWithVerifiedCard) {
    buttonCopy = 'View checking account';
  } else {
    buttonCopy = '';
    shouldDisplayFlash = true;
  }

  const viewProps = {
    handleClick,
    buttonCopy,
    displayFlash: shouldDisplayFlash,
  };

  return (
    <ModalOverlay>
      <ModalContent aria-label="no fee checking splash">
        <CloseButton closeHandler={() => locationAssign(returnToPath)} />
        <NoFeeChecking {...viewProps} />
      </ModalContent>
    </ModalOverlay>
  );
};

export default NoFeeCheckingSplash;
